import { LoggerStrategies } from 'src/app/constants/logger';

const metaTag = {
  title: 'Portal de administración',
  description: 'Todo lo que necesitas en un solo lugar',
  image: 'https://upload.wikimedia.org/wikipedia/commons/a/a6/Unitec-logo.jpg',
  url: 'https://untc-servicios-admin-uat.azurewebsites.net/'
}

const keycloak = {
  url: 'https://laureateaks-qa.eastus.cloudapp.azure.com/auth',
  realm: 'servicios-digitales-admin-unitec',
  clientId: 'servicios-digitales-admin',
  logoutUrl: 'https://laureatemx.identity.secureauth.com/SecureAuth118/Logout.aspx'
};

const sse = {
  url: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/sse',
  retryInterval: 5000,
  maxRetries: 10,
};

const loggerStrategy = LoggerStrategies.GOOGLE;

export const environment = {
  firebase: {
    projectId: 'angular-archetype',
    appId: '1:345615968686:web:072040fdd8edc70ceb403f',
    storageBucket: 'angular-archetype.appspot.com',
    apiKey: 'AIzaSyA9fQB2c1yCxwhjMVFBfWW0DfNBUAhwqCc',
    authDomain: 'angular-archetype.firebaseapp.com',
    messagingSenderId: '345615968686',
    measurementId: 'G-W650607S7L',
  },
  production: true,
  theme: 'unitec-theme',
  baseUrl: 'https://reqres.in/api',
  usersURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/user',
  catalogsURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/catalogs',
  libraryURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/library',
  digitalFileURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/digitalfile',
  digitalFileMasiveURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/digitalfilemasive',
  calendarsURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/calendar',
  notificationURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/notification',
  monitoringURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/cnf',
  recordLogURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/recordlog',
  configURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/config',
  studentURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/student',
  tipificationsURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/activities',
  constancyURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/constancy',
  paymentURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/payment',
  surveyURL: 'https://laureateaks-qa.eastus.cloudapp.azure.com/api/sdig/untc/admin/student/notice',
  keycloak,
  sse,
  loggerStrategy,
  portal: 'unitec',
  origen: 'admin-web',
  site: 'PDA',
  genericUserTickets: "alan@mail.unitec.mx",
  metaTag
};
